import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function WhatIsSection() {
  const isList = ['Elegir una idea vendible', 'Definir una audiencia real', 'Crear tu producto digital (PDF/plantillas/workbook)', 'Publicarlo con un mensaje claro', 'Y venderlo con más seguridad (sin sentirte invasiva)'];
  const isNotList = ['No es un curso eterno.', 'No es "hazte viral".', 'No es teoría bonita sin acción.', 'No es una promesa de ingresos.'];
  return <section className="py-20 px-4 bg-white" data-id="element-181">
      <div className="max-w-5xl mx-auto" data-id="element-182">
        <div className="text-center mb-16" data-id="element-183">
          <h2 className="text-3xl md:text-5xl font-serif text-brown-800 mb-4" data-id="element-184">
            ¿Qué es el Plan 14 Días?
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto" data-id="element-185">
            Plan 14 Días: Tu Primer Producto Digital (con Propósito) es una guía
            práctica para:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-186">
          {/* What It Is */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-cream-50 p-8 rounded-3xl border border-cream-200" data-id="element-187">
            <h3 className="text-2xl font-serif text-brown-800 mb-6 flex items-center gap-3" data-id="element-188">
              <span className="bg-sage-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-189">
                <CheckIcon className="w-5 h-5" data-id="element-190" />
              </span>
              Lo que SÍ es
            </h3>
            <ul className="space-y-4" data-id="element-191">
              {isList.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-192">
                  <CheckIcon className="w-5 h-5 text-sage-500 flex-shrink-0 mt-1" data-id="element-193" />
                  <span className="text-brown-800" data-id="element-194">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* What It Is NOT */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 rounded-3xl border-2 border-cream-100" data-id="element-195">
            <h3 className="text-2xl font-serif text-brown-800 mb-6 flex items-center gap-3" data-id="element-196">
              <span className="bg-terracotta-500 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-197">
                <XIcon className="w-5 h-5" data-id="element-198" />
              </span>
              Lo que NO es
            </h3>
            <ul className="space-y-4" data-id="element-199">
              {isNotList.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-200">
                  <XIcon className="w-5 h-5 text-terracotta-500 flex-shrink-0 mt-1" data-id="element-201" />
                  <span className="text-stone-600" data-id="element-202">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-203">
          <div className="inline-block bg-brown-800 text-cream-50 px-8 py-4 rounded-full text-xl font-medium shadow-lg" data-id="element-204">
            Es: claridad + estructura + ejecución.
          </div>
        </motion.div>
      </div>
    </section>;
}